import { render, staticRenderFns } from "./ResourceCenter.vue?vue&type=template&id=3d01139c&scoped=true"
import script from "./ResourceCenter.vue?vue&type=script&lang=js"
export * from "./ResourceCenter.vue?vue&type=script&lang=js"
import style0 from "./ResourceCenter.vue?vue&type=style&index=0&id=3d01139c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d01139c",
  null
  
)

export default component.exports